export enum UserFormState {
    None = "",
    Saving = "Saving...",
    Saved = "Saved",
    Error = "Save Failed"
  }
  